module.exports = __webpack_public_path__ + "static/media/partners_illustration.89e36bad.png";